import { render, staticRenderFns } from "./WhatDoYouDrive.vue?vue&type=template&id=5c48e550&scoped=true&lang=pug&"
import script from "./WhatDoYouDrive.vue?vue&type=script&lang=js&"
export * from "./WhatDoYouDrive.vue?vue&type=script&lang=js&"
import style0 from "./WhatDoYouDrive.vue?vue&type=style&index=0&id=5c48e550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48e550",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCol,VImg,VRow,VSelect})
